
// declare var gtag: any;
// declare var dataLayer: any;
// declare var ga: any;
declare var window: any;

export class GoogleAnalyticsService {

  private gtag: any;
  isInit: boolean = false;
  siteId!: string;
  isEnabled: boolean = true;

  constructor(private googleAnalyticsConfig: any) {
    this.siteId = googleAnalyticsConfig.siteId;
    this.isEnabled = googleAnalyticsConfig.isEnabled;
    if(this.isEnabled){
      this.loadScript();
    }
  }

  // private loadScript() {
  //   if (document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${this.siteId}"]`)) {
  //     // Lo script è già stato caricato
  //     return;
  //   }

  //   const script = document.createElement('script');
  //   script.async = true;
  //   script.src = `https://www.googletagmanager.com/gtag/js?id=${this.siteId}`;
  //   document.head.appendChild(script);

  //   script.onload = () => {
  //     this.initializeGtag();
  //   };
  // }

  private loadScript() {
    if (document.querySelector(`script[src="https://www.googletagmanager.com/gtm.js?id=${this.siteId}"]`)) {
      // Lo script è già stato caricato
      return;
    }

    this.appendScript();
  }

  private appendScript() {
    ((w, d, s, l, i) => {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      var f: any = d.getElementsByTagName(s)[0],
        j: any = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
      j.onload = () => {
        this.initializeGtag();
      };
    })(window, document, 'script', 'dataLayer', this.siteId);

    // this.initializeGtag();
  }

  private initializeGtag() {
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) {
      (window as any).dataLayer.push(args);
    }
    this.gtag = gtag;
    this.gtag('js', new Date());
    this.gtag('config', this.siteId);

    this.isInit = true;
  }

  public sendEvent(eventName: string, eventParams: { [key: string]: any }) {
    if(!this.isEnabled){
      return;
    }
    if (!this.gtag || !this.isInit) {
      console.warn('GA4 is not initialized yet.');
      return;
    }
    this.gtag('event', eventName, eventParams);
  }

  public sendPageView(pagePath: string) {
    if(!this.isEnabled){
      return;
    }
    if (!this.gtag || !this.isInit) {
      console.warn('GA4 is not initialized yet.');
      return;
    }
    this.gtag('event', 'page_view', { page_path: pagePath });
  }

  private pingHome(obj: any) {
    if(!this.isEnabled){
      return;
    }
    if (!this.gtag || !this.isInit) {
      console.warn('GA4 is not initialized yet.');
      return;
    }
    if (obj) this.gtag(obj);
  }

  logPageView(url: string) {
    const hit = {
      event: 'content-view',
      pageName: url
    };
    this.pingHome(hit);
  }
  logEvent(event: string, category: string, action: string, label: string) {
    const hit = {
      event: event,
      category: category,
      action: action,
      label: label
    };
    this.pingHome(hit);
  }
  logCustomDimensionTest(value: any) {
    const hit = {
      event: 'custom-dimension',
      value: value
    };
    this.pingHome(hit);
  }
}
